export enum SinglePageState {
    Waiting,
    Scanning,
    Sending,
    Result,
    Error
}